import { Component, OnInit, OnDestroy } from '@angular/core';
import { PershingTranslationService, PermissionCheckerService } from '@pershing/pershing-core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';
import { Router } from '@angular/router';
import { NavigationConstants } from '../utils/navigation.constants';

@Component({
    selector: 'screener-navigation-custom',
    templateUrl: 'screener-navigation-custom.component.html'
})
export class ScreenerNavCustomComponent implements OnInit, OnDestroy {
    fourthNavLinks: any[];
    selectedFourthPageId: any;
    navigation: NxiNavigation;
    layout: string;
    currentUrl: string;
    isEntitledStockScreener: boolean;
    isEntitledETFScreener: boolean;
    isEntitledMFScreener: boolean;

    constructor(
        private translationService: PershingTranslationService,
        private navigationService: PortalNavigationService,
        private router: Router,
        private authService: PermissionCheckerService) { }

    ngOnInit(): void {
        console.log(' In Component OnInit ');
        this.isEntitledStockScreener = this.authService.isEntitled(NavigationConstants.MOD_STOCK_SCREENER);
        this.isEntitledETFScreener = this.authService.isEntitled(NavigationConstants.MOD_ETF_SCREENER);
        this.isEntitledMFScreener = this.authService.isEntitled(NavigationConstants.MOD_MUTUAL_FUND_SCREENER);
        this.currentUrl = this.router.url;
        this.currentUrl = this.currentUrl.slice(this.currentUrl.lastIndexOf('/') + 1);
        this.navigationService.getGrandChildPage().subscribe(
            currentpage => {
                if (currentpage !== undefined) {
                    this.selectedFourthPageId = currentpage.id;
                    if (currentpage.children !== undefined) {
                        this.fourthNavLinks = currentpage.children;
                        if (this.fourthNavLinks.length > 0) {
                            this.selectedFourthPageId = this.fourthNavLinks[0].id;
                            // this.layout = this.fourthNavLinks[0].layout;
                            console.log(' 4rd grandchildpage-- ' + this.selectedFourthPageId);
                        }
                    }
                }
            });
    }
    public ngOnDestroy() {
        console.log(' In FourthLevelComponent Destroy ');
    }
    handleChildNavigation(pageName): void {
        console.log('screeners Nav: ', pageName);
        this.currentUrl = pageName;
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'domain': 'account',
                'value': '',
                'gotoPage': '/nxi/research/investtools/securitysearch/' + pageName
            }
        }));
    }
}
